import { render, staticRenderFns } from "./ItemizedPayments.vue?vue&type=template&id=22182a8a&scoped=true&"
import script from "./ItemizedPayments.vue?vue&type=script&lang=js&"
export * from "./ItemizedPayments.vue?vue&type=script&lang=js&"
import style0 from "./ItemizedPayments.vue?vue&type=style&index=0&id=22182a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22182a8a",
  null
  
)

export default component.exports